<template>
    <div>
        <div
            ref="collapsibles"
            id="accordion_new_object"
            class="lb-accordion pb-6"
        >
            <!-- Object type section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-type"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'type'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-ray-start-end
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{
                                                    $t('Zone.element_type')
                                                }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-type"
                    class="message-body object-zone is-collapsible is-active"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <div class="field mb-5">
                            <label class="label">{{
                                $t('Zone.select_element_type')
                            }}</label>
                            <div class="tabs is-toggle is-fullwidth">
                                <ul>
                                    <li
                                        :class="{
                                            'is-active':
                                                elementType == 'object',
                                        }"
                                    >
                                        <a
                                            class=""
                                            @click="elementType = 'object'"
                                        >
                                            <span
                                                class="
                                                    is-uppercase
                                                    has-text-weight-bold
                                                "
                                                >{{ $t('Zone.object') }}</span
                                            >
                                        </a>
                                    </li>
                                    <li
                                        :class="{
                                            'is-active':
                                                elementType == 'question',
                                        }"
                                    >
                                        <a
                                            class=""
                                            @click="elementType = 'question'"
                                        >
                                            <span
                                                class="
                                                    is-uppercase
                                                    has-text-weight-bold
                                                "
                                                >{{ $t('Zone.question') }}</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- General info section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-information"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'information'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span
                                            v-if="elementType != 'question'"
                                            class="icon-text"
                                        >
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-information-outline
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{
                                                    $t(
                                                        'project.settings.general_information'
                                                    )
                                                }}</span
                                            >
                                        </span>
                                        <span v-else class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-crosshairs-question
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('App.question') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-information"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <div
                            class="field mb-5"
                            v-if="model.title || content.title"
                        >
                            <label
                                class="label"
                                v-if="elementType != 'question'"
                                >{{ $t('Object.title_label') }}</label
                            >
                            <label class="label" v-else>{{
                                $t('Object.question_label')
                            }}</label>
                            <div class="control">
                                <textarea
                                    v-model="content.title"
                                    class="textarea"
                                />
                            </div>
                        </div>
                        <div
                            class="field mb-5"
                            v-if="model.description || content.description"
                        >
                            <label class="label">{{
                                $t('Object.description_label')
                            }}</label>
                            <div class="control">
                                <input-rich-text
                                    class="lb-bordered"
                                    v-if="model.description"
                                    v-model="content.description"
                                    :editable="true"
                                    :placeholder="descriptionPlaceholder"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <!-- Answers section -->
            <article
                id="answers-section"
                class="message"
                v-show="elementType == 'question'"
            >
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-answers"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'answers'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-format-list-numbered-rtl
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.answers') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-answers"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <object-card-related
                            v-if="model.related"
                            :show-creation="true"
                            :answers.sync="content.answers"
                            :answer-type.sync="content.answerType"
                        />
                    </div>
                </div>
            </article>

            <!-- images section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-images"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'images'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="fa fa-lg fa-images"
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.images') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-images"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_images_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- errors section -->
                        <div class="mt-4">
                            <div
                                class="notification is-danger is-light"
                                v-for="(error, index) in imagesErrors"
                                :key="index"
                            >
                                <button
                                    class="delete"
                                    @click="removeMessage('images', index)"
                                ></button>
                                <div v-html="error" />
                            </div>
                        </div>

                        <!-- content section -->
                        <vue-dropzone
                            ref="imagesDropzone"
                            id="dropzone"
                            :options="imagesDropzoneOptions"
                            :useCustomSlot="true"
                            class="my-4"
                            @vdropzone-success="imageAdded"
                            @vdropzone-error="uploadImageError"
                        >
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">
                                    {{ $t('Object.drag_and_drop_files_here') }}
                                </h3>
                            </div>
                        </vue-dropzone>
                        <draggable
                            @end="imagesDragEndHandler"
                            class="visualizacao sortable dropzone-previews"
                        ></draggable>

                        <!-- preview template -->
                        <div
                            class="preview"
                            style="display: none"
                            ref="image-preview-template"
                            id="image-preview-template"
                        >
                            <li>
                                <div>
                                    <div class="dz-preview dz-file-preview">
                                        <figure class="image is-1by1">
                                            <img data-dz-thumbnail />
                                        </figure>
                                        <div class="dz-filename is-size-7">
                                            <span data-dz-name=""></span>
                                        </div>
                                        <div class="dz-progress">
                                            <span
                                                class="dz-upload"
                                                data-dz-uploadprogress
                                            ></span>
                                        </div>
                                        <div class="dz-success-mark">
                                            <!--<span>✔</span>-->
                                            <span
                                                class="
                                                    icon
                                                    is-small
                                                    has-text-primary
                                                    mt-1
                                                "
                                            >
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-18px
                                                        mdi-check-circle-outline
                                                    "
                                                ></i>
                                            </span>
                                        </div>
                                        <div class="dz-error-mark">
                                            <span>✘</span>
                                        </div>
                                        <div class="dz-error-message">
                                            <span data-dz-errormessage></span>
                                        </div>
                                        <a class="dz-remove" data-dz-remove="">
                                            <span
                                                class="
                                                    icon
                                                    is-small
                                                    has-text-danger
                                                    mt-1
                                                "
                                            >
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-18px
                                                        mdi-trash-can
                                                    "
                                                ></i> </span
                                        ></a>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </div>
                </div>
            </article>

            <!-- audio section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-audio"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'audio'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="fa fa-lg fa-music"
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.audio') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-audio"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_audio_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- errors section -->
                        <div class="mt-4">
                            <div
                                class="notification is-danger is-light"
                                v-for="(error, index) in audioErrors"
                                :key="index"
                            >
                                <button
                                    class="delete"
                                    @click="removeMessage('audio', index)"
                                ></button>
                                <div v-html="error" />
                            </div>
                        </div>

                        <!-- content section -->
                        <vue-dropzone
                            ref="audioDropzone"
                            id="audio-dropzone"
                            :options="audioDropzoneOptions"
                            :useCustomSlot="true"
                            class="my-4"
                            @vdropzone-error="uploadAudioError"
                            @vdropzone-success="audioFileAdded"
                        >
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">
                                    {{
                                        $t(
                                            'Object.drag_and_drop_audio_file_here'
                                        )
                                    }}
                                </h3>
                                <p class="subtitle is-size-7 has-text-grey">
                                    {{ $t('Object.upload_audio_desc') }}
                                </p>
                            </div>
                        </vue-dropzone>

                        <ul class="audio-preview-file dropzone-previews"></ul>

                        <!-- preview template -->
                        <div
                            class="preview"
                            style="display: none"
                            ref="audio-preview-template"
                            id="audio-preview-template"
                        >
                            <li>
                                <div>
                                    <div class="dz-preview dz-file-preview">
                                        <div class="dz-progress">
                                            <span
                                                class="dz-upload"
                                                data-dz-uploadprogress
                                            ></span>
                                        </div>
                                        <div
                                            class="
                                                columns
                                                is-mobile is-vcentered
                                            "
                                        >
                                            <div class="column is-10 px-5 py-5">
                                                <div
                                                    class="
                                                        dz-filename
                                                        is-size-6
                                                    "
                                                >
                                                    <span
                                                        data-dz-name=""
                                                    ></span>
                                                </div>
                                                <div class="dz-size is-size-7">
                                                    <span
                                                        data-dz-size=""
                                                    ></span>
                                                </div>
                                            </div>
                                            <div
                                                class="
                                                    column
                                                    is-2
                                                    has-text-right
                                                    pr-5
                                                "
                                            >
                                                <a
                                                    class="dz-remove"
                                                    data-dz-remove=""
                                                >
                                                    <span
                                                        class="
                                                            icon
                                                            has-text-danger
                                                            mt-1
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-24px
                                                                mdi-trash-can
                                                            "
                                                        ></i> </span
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </div>
                </div>
            </article>

            <!-- files section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-files"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'files'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i class="fa fa-lg fa-file"></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.files') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-files"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_files_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- errors section -->
                        <div class="mt-4">
                            <div
                                class="notification is-danger is-light"
                                v-for="(error, index) in filesErrors"
                                :key="index"
                            >
                                <button
                                    class="delete"
                                    @click="removeMessage('files', index)"
                                ></button>
                                <div v-html="error" />
                            </div>
                        </div>

                        <!-- content section -->
                        <vue-dropzone
                            ref="filesDropzone"
                            id="files-dropzone"
                            :options="filesDropzoneOptions"
                            :useCustomSlot="true"
                            class="my-4"
                            @vdropzone-error="uploadFilesError"
                            @vdropzone-success="filesAdded"
                        >
                            <div class="dropzone-custom-content">
                                <h3 class="dropzone-custom-title">
                                    {{ $t('Object.drag_and_drop_files_here') }}
                                </h3>
                                <p class="subtitle is-size-7 has-text-grey">
                                    {{ $t('Object.upload_files_desc') }}
                                </p>
                            </div>
                        </vue-dropzone>

                        <draggable
                            @end="filesDragEndHandler"
                            class="files-preview-file dropzone-previews"
                        ></draggable>

                        <!-- preview template -->
                        <div
                            class="preview"
                            style="display: none"
                            ref="files-preview-template"
                            id="files-preview-template"
                        >
                            <li>
                                <div>
                                    <div class="dz-preview dz-file-preview">
                                        <div class="dz-progress">
                                            <span
                                                class="dz-upload"
                                                data-dz-uploadprogress
                                            ></span>
                                        </div>
                                        <div
                                            class="
                                                columns
                                                is-mobile is-vcentered
                                            "
                                        >
                                            <div class="column is-10 px-5 py-5">
                                                <div
                                                    class="
                                                        dz-filename
                                                        is-size-6
                                                    "
                                                >
                                                    <span
                                                        data-dz-name=""
                                                    ></span>
                                                </div>
                                                <div class="dz-size is-size-7">
                                                    <span
                                                        data-dz-size=""
                                                    ></span>
                                                </div>
                                            </div>
                                            <div
                                                class="
                                                    column
                                                    is-2
                                                    has-text-right
                                                    pr-5
                                                "
                                            >
                                                <a
                                                    class="dz-remove"
                                                    data-dz-remove=""
                                                >
                                                    <span
                                                        class="
                                                            icon
                                                            has-text-danger
                                                            mt-1
                                                        "
                                                    >
                                                        <i
                                                            class="
                                                                mdi
                                                                mdi-24px
                                                                mdi-trash-can
                                                            "
                                                        ></i> </span
                                                ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </div>
                </div>
            </article>

            <!-- video section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-video"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'video'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi mdi-24px mdi-youtube
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.video') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-video"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_video_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <label class="label">{{
                            $t('Object.video_label')
                        }}</label>
                        <div class="field">
                            <div class="control is-expanded">
                                <input
                                    v-model="content.video"
                                    class="input"
                                    type="text"
                                    @input="validateVideoURL"
                                />
                            </div>
                        </div>
                        <p v-if="objectErrors.video" class="help is-danger">
                            {{ objectErrors.video }}
                        </p>
                    </div>
                </div>
            </article>

            <!-- embed section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-embed"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'embed'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-code-tags
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.embed') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-embed"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_embed_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <label class="label">{{
                            $t('Object.embed_label')
                        }}</label>
                        <div class="field">
                            <div class="control is-expanded">
                                <textarea
                                    v-model="content.embed"
                                    class="textarea"
                                    rows="4"
                                    @input="validateEmbedCode"
                                />
                            </div>
                        </div>
                        <p v-if="objectErrors.embed" class="help is-danger">
                            {{ objectErrors.embed }}
                        </p>
                    </div>
                </div>
            </article>

            <!-- tags section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-tags"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'tags'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-tag-multiple
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.tags') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-tags"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_tags_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <label class="label">{{
                            $t('Object.tags_label')
                        }}</label>
                        <l-project-object-input-tags v-model="content.tags" />
                    </div>
                </div>
            </article>

            <!-- url section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a
                        href="#accordion_new_object-url"
                        data-action="collapse"
                        style="width: 100%"
                        :ref="'url'"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-link-variant
                                                    "
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{ $t('Object.url') }}</span
                                            >
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                        </nav>
                    </a>
                </div>
                <div
                    id="accordion_new_object-url"
                    class="message-body object-zone is-collapsible"
                    data-parent="accordion_new_object"
                    data-allow-multiple="false"
                >
                    <div class="message-body-content px-4 py-4">
                        <!-- helper section -->
                        <div class="is-flex is-flex-direction-row-reverse">
                            <span
                                :data-tippy-content="
                                    $t('Object.object_url_description')
                                "
                                class="
                                    icon
                                    is-small
                                    has-text-grey-light
                                    creation-helper
                                "
                                ><i
                                    class="mdi mdi-24px mdi-help-circle-outline"
                                ></i
                            ></span>
                        </div>

                        <!-- content section -->
                        <div class="field">
                            <label class="label">{{
                                $t('Object.url_label')
                            }}</label>
                            <div class="control">
                                <input
                                    class="input"
                                    type="text"
                                    v-model="content.url"
                                    @input="validateURL"
                                />
                            </div>
                        </div>
                        <p v-if="objectErrors.url" class="help is-danger">
                            {{ objectErrors.url }}
                        </p>
                    </div>
                </div>
            </article>
        </div>

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('Object.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('Object.errors_on_save_desc') }}
                </p>
                <br />
                <p
                    class="is-size-6 has-text-italic"
                    v-for="(error, index) in objectErrors"
                    :key="index"
                >
                    - {{ error }}
                </p>
            </div>
        </div>

        <!-- action buttons -->
        <div
            class="
                columns
                is-mobile
                action-buttons
                px-0
                py-0
                has-background-white
            "
        >
            <div class="column is-4 px-0 py-0">
                <button
                    v-t="'cancel'"
                    class="
                        button
                        is-black is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="discardUnsavedChanges"
                />
            </div>
            <div class="column is-4 px-0 py-0">
                <button
                    class="
                        button
                        is-success is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    style="height: 100%"
                    @click="showPreview"
                    v-t="'Object.preview'"
                />
            </div>
            <div class="column is-4 px-0 py-0">
                <button
                    v-t="'Buttons.save'"
                    :class="{ 'is-loading': saving }"
                    class="
                        button
                        is-primary is-uppercase
                        has-text-weight-bold
                        is-fullwidth is-size-6 is-radiusless
                    "
                    @click="validateAndSave"
                />
            </div>
        </div>

        <l-projectObject-modal-preview
            v-if="showModalPreview"
            :type="previewType"
            :content="previewData"
            :active.sync="showModalPreview"
            @close="showModalPreview = false"
        />

        <l-project-object-preview
            :object="content"
            v-if="showPreviewModal"
            @close="showPreviewModal = false"
        />
    </div>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import GeoCodingOSM from 'geocoding-osm';
import tippy, { createSingleton } from 'tippy.js';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import LProjectObjectModalPreview from '@/components/LProjectObjectModalPreview';
import LProjectObjectInputTags from '@/components/LProjectObjectInputTags';
import LProjectObjectPreview from '@/components/LProjectObjectPreview';
import InputURL from '@/components/InputURL';
import ObjectCardRelated from '@/components/ObjectCardRelated';

export default {
    name: 'LProjectObject',
    components: {
        InputRichText,
        vueDropzone: vue2Dropzone,
        draggable,
        LProjectObjectInputTags,
        LProjectObjectModalPreview,
        LProjectObjectPreview,
        InputURL,
        ObjectCardRelated,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            imagesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.visualizacao',
                parallelUploads: 1,
                //disablePreviews: true,
                acceptedFiles: 'image/gif,image/jpeg,image/png',
                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            audioDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.audio-preview-file',
                acceptedFiles: 'audio/mpeg',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            showAudioPlayer: false,
            audioFile: '',

            filesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.files-preview-file',
                acceptedFiles:
                    'application/pdf,application/vnd.ms-powerpoint,application/zip,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/epub+zip,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            videoId: undefined,
            embedCode: undefined,
            showEmbedPreview: false,

            showModalPreview: false,
            previewType: undefined,
            previewData: undefined,

            showPreviewModal: false,

            saving: false,
            originalContent: {},

            objectErrors: {},
            filesErrors: [],
            audioErrors: [],
            imagesErrors: [],
            errorsOnSave: false,

            elementType: 'question',
            model: this.$store.getters.questionModel,
        };
    },
    computed: {
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        titlePlaceholder() {
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return 'creation.treasurehunt_title_hint';
            }
            return 'creation.title_hint';
        },
        descriptionPlaceholder() {
            if (
                this.$store.getters.project.type == 'treasurehunt' &&
                this.$store.getters.projectContent.length == 1
            ) {
                return this.$t('creation.treasurehunt_description_hint');
            }
            return '';
        },
        hasChanges() {
            return this.content !== this.originalContent;
        },
        correctAnswers() {
            // console.log('object', this.content);
            // console.log('answers', this.content.answers);
            // console.log('answerType', this.content.answerType);
            return _.filter(this.content.answers, (answer) => {
                if (answer.correct) {
                    return answer && answer.value;
                }
            });
        },
        cleanedAnswers() {
            return _.filter(this.content.answers, (answer) => {
                if (answer.value) {
                    return answer;
                }
            });
        },
    },
    watch: {
        elementType: {
            handler: function () {
                // console.log('change type', this.elementType);
                if (this.elementType == 'object') {
                    this.model = this.$store.getters.objectModel;
                } else {
                    this.model = this.$store.getters.questionModel;
                }
            },
            immediate: true,
        },
        
    },
    mounted() {
        const collapsibles = bulmaCollapsible.attach('.object-zone', {allowMultiple: false});
        const tippyInstances = tippy('[data-tippy-content]');
        const singleton = createSingleton(tippyInstances, {
            delay: 100,
            moveTransition: 'transform 0.2s ease-out',
            placement: 'right',
            theme: 'tippylabyloksolid',
            allowHTML: true,
            trigger: 'click',
            animation: 'shift-away',
            offset: [0, 20],
        });

        this.$refs['imagesDropzone'].setOption(
            'previewTemplate',
            document.getElementById('image-preview-template').innerHTML
        );
        this.$refs['audioDropzone'].setOption(
            'previewTemplate',
            document.getElementById('audio-preview-template').innerHTML
        );
        this.$refs['filesDropzone'].setOption(
            'previewTemplate',
            document.getElementById('files-preview-template').innerHTML
        );
        this.originalContent = { ...this.content };
        // console.log(localStorage.getItem('token'));
        // console.log('data', this.model, this.content);

        if (this.content.images) {
            // console.log('content images', this.content.images);
            this.content.images.forEach((image) => {
                /*console.log(image);
                this.$refs['imagesDropzone'].manuallyAddFile(image, image.url);*/
                let file = {
                    size: image.size,
                    name: image.name,
                    type: image.mimeType,
                    draggable: true,
                };
                let url = image.url;
                this.$refs['imagesDropzone'].manuallyAddFile(file, url);
            });
        }

        if (this.content.audio) {
            // console.log('content audio', this.content.audio);
            let file = {
                size: this.content.audio.size,
                name: this.content.audio.name,
                type: this.content.audio.mimeType,
                draggable: true,
            };
            let url = this.content.audio.url;
            this.$refs['audioDropzone'].manuallyAddFile(file, url);
        }

        if (this.content.files) {
            // console.log('content files', this.content.files);
            this.content.files.forEach((elemet) => {
                let file = {
                    size: elemet.size,
                    name: elemet.name,
                    type: elemet.mimeType,
                    draggable: true,
                };
                let url = elemet.url;
                this.$refs['filesDropzone'].manuallyAddFile(file, url);
            });
        }
    },
    beforeDestroy() {
        //this.$refs['imagesDropzone'].
    },
    destroyed() {},
    methods: {
        
        questionValidator() {
            if (this.objectErrors['answers']) {
                delete this.objectErrors['answers'];
            }
            if (this.objectErrors['question']) {
                delete this.objectErrors['question'];
            }
            if (this.objectErrors['questionType']) {
                delete this.objectErrors['questionType'];
            }
            if (!this.content.title) {
                //return 'Object.errors.FILL_QUESTION';
                this.objectErrors['question'] = this.$t(
                    `Object.errors.FILL_QUESTION`
                );
            }

            if (!this.content.answerType) {
                this.objectErrors['questionType'] = this.$t(
                    `Object.errors.QUESTION_TYPE`
                );
                return;
            }

            // console.log(this.content.answers, this.correctAnswers);
            if (
                this.content.answerType == 'HANGMAN' ||
                this.content.answerType == 'FREETEXT'
            ) {
                if (!this.content.answers || !this.content.answers.length) {
                    // console.log('hangman, freetext no answer');
                    // return 'Object.errors.FILL_ANSWER';
                    this.objectErrors['answers'] = this.$t(
                        `Object.errors.FILL_ANSWER`
                    );
                    return;
                }
                if (this.correctAnswers.length) {
                    this.cleanAnswers(); // removes emtpy answers
                    this.content.answers = [this.correctAnswers[0]]; // ensure only one answer for this question type
                } else {
                    // return 'Object.errors.MARK_CORRECT';
                    // console.log('hangman, freetext no correct');
                    this.objectErrors['answers'] = this.$t(
                        `Object.errors.MARK_CORRECT`
                    );
                    return;
                }
            } else {
                if (!this.content.answers || !this.content.answers.length) {
                    // return 'Object.errors.FILL_ANSWERS';
                    // console.log('simple, multiple no answers');
                    this.objectErrors['answers'] = this.$t(
                        `Object.errors.FILL_ANSWERS`
                    );
                    return;
                }
                this.cleanAnswers(); // removes emtpy answers
                // console.log(this.correctAnswers, this.content.answers);
                if (this.correctAnswers.length < 1) {
                    // console.log('simple, multiple no correct');
                    //return 'Object.errors.MARK_CORRECT';
                    this.objectErrors['answers'] = this.$t(
                        `Object.errors.MARK_CORRECT`
                    );
                    return;
                }
            }
            return 'ALL_OK';
        },
        cleanAnswers() {
            this.content.answers = this.cleanedAnswers;
        },
        validateAndSave() {
            //TODO: validate also type
            if (this.$store.getters.project.type === 'trivial') {
                const responseValidator = this.questionValidator();
                if (responseValidator !== 'ALL_OK') {
                    // alert(this.$t(responseValidator));
                    //return;
                    this.errorsOnSave = true;
                }
            }
            // console.log('model', this.model);
            const requiredMedia = _.chain(this.model.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            // console.log('required media', requiredMedia);
            const requiredProps = _.chain(this.model)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();
            // console.log('required props', requiredProps);

            const requiredFields = requiredProps.concat(requiredMedia);

            // console.log('required fields', requiredFields);
            const props = _.chain(requiredFields);
            // console.log('props', props);
            props.forEach((prop) => {
                if (this.content[prop]) {
                    let dataLenght = 0;
                    if (typeof this.content[prop] == 'object') {
                        dataLenght = Object.keys(this.content[prop]).length;
                    } else {
                        dataLenght = this.content[prop].lenght;
                    }
                    if (dataLenght === 0) {
                        this.objectErrors[prop] = this.$t(
                            `Object.missing_${prop}_value`
                        );
                    } else {
                        if (this.objectErrors[prop]) {
                            delete this.objectErrors[prop];
                        }
                    }
                } else {
                    this.objectErrors[prop] = this.$t(
                        `Object.missing_${prop}_value`
                    );
                }
            });

            // console.log(this.objectErrors);
            const isValid = Object.keys(this.objectErrors).length === 0;
            if (isValid) {
                this.$emit('save');
                // console.log('is valid object');
            } else {
                this.errorsOnSave = true;
            }
        },
        async searchAddress() {
            let searchLocale = this.$i18n.locale;
            if (this.$i18n.locale === 'ca-ES') {
                searchLocale = 'ca_ES';
            }
            if (this.searchText.length > 5) {
                const searchParams = {
                    q: this.searchText,
                    'accept-language': searchLocale,
                    limit: 1,
                };
                const geoCodingOSM = new GeoCodingOSM();

                const response = await geoCodingOSM.search(searchParams);

                if (response[0]) {
                    this.$emit('addPoint', response[0]);
                    // console.log(this.content);
                }
            }
        },
        goToPos() {
            // console.log('in go to pos', this.content);
            if (this.content.location) {
                // console.log('has content location');
                if (
                    this.isLatitude(this.content.location.latitude) &&
                    this.isLongitude(this.content.location.longitude)
                ) {
                    this.$emit('addPoint', {
                        lat: this.content.location.latitude,
                        lon: this.content.location.longitude,
                    });
                }
            }
        },
        isLatitude(maybeLat) {
            var latF = parseFloat(maybeLat);
            if (isNaN(latF)) return false;
            return latF >= -90 && latF <= 90;
        },
        isLongitude(maybeLon) {
            var lonF = parseFloat(maybeLon);
            if (isNaN(lonF)) return false;
            return lonF >= -180 && lonF <= 180;
        },
        removeLocationNotification() {
            // console.log(this.$refs);
            this.$refs.location_notification.hidden = true;
        },
        imageAdded(file, response) {
            // console.log('adding file', file, response);
            if (!this.content.images) {
                this.content.images = [];
            }
            this.content.images.push(response.file);
        },
        uploadImageError(file, message, xhr) {
            this.$refs['imagesDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.imagesErrors.push(errorMessage);
        },
        uploadAudioError(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['audioDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.audioErrors.push(errorMessage);
        },
        audioFileAdded(file, response) {
            this.content.audio = response.file;
            // console.log(file, response);
            // this.audioFile = response.file.url;
            // console.log(response.file.url);
            // this.showAudioPlayer = true;
        },
        uploadFilesError(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['filesDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.filesErrors.push(errorMessage);
        },
        removeMessage(type, index) {
            if (type == 'files') {
                this.filesErrors.splice(index, 1);
            } else if (type == 'audio') {
                this.audioErrors.splice(index, 1);
            } else if (type == 'images') {
                this.imagesErrors.splice(index, 1);
            }
        },
        filesAdded(file, response) {
            // console.log(file, response);
            if (!this.content.files) {
                this.content.files = [];
            }
            this.content.files.push(response.file);
        },
        previewVideo() {
            if (this.content.video) {
                this.previewData = this.$youtube.getIdFromUrl(
                    this.content.video
                );
                this.previewType = 'video';
                this.showModalPreview = true;
            }
        },
        previewEmbed() {
            if (this.content.embed) {
                this.previewType = 'embed';
                this.previewData = this.content.embed;
                this.showModalPreview = true;
            }
        },
        previewImages() {
            // console.log(this.content.images);
            if (this.content.images) {
                this.previewType = 'images';
                this.previewData = this.content.images;
                this.showModalPreview = true;
            }
        },
        showPreview() {
            this.showPreviewModal = true;
        },
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },

        /* data validations */
        validateVideoURL(event) {
            if (event.target.value.length) {
                const re =
                    /(\?v=([^#\&\?]{11}))|(youtu\.be\/([^#\&\?]{11})|(\&v=([^#\&\?]{11}))|(embed\/([^#\&\?]{11}))|(\/v\/([^#\&\?]{11})))/;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.video) {
                        delete this.objectErrors.video;
                    }
                } else {
                    this.objectErrors.video = this.$t(
                        'Object.invalid_video_url'
                    );
                }
            } else {
                if (this.objectErrors.video) {
                    delete this.objectErrors.video;
                }
            }
        },
        validateEmbedCode(event) {
            if (event.target.value.length) {
                const re = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.embed) {
                        delete this.objectErrors.embed;
                    }
                } else {
                    this.objectErrors.embed = this.$t(
                        'Object.invalid_embed_code'
                    );
                }
            } else {
                if (this.objectErrors.embed) {
                    delete this.objectErrors.embed;
                }
            }
        },
        validateURL(event) {
            if (event.target.value.length) {
                const re =
                    /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
                if (re.test(event.target.value)) {
                    if (this.objectErrors.url) {
                        delete this.objectErrors.url;
                    }
                } else {
                    this.objectErrors.url = this.$t('Object.invalid_url');
                }
            } else {
                if (this.objectErrors.url) {
                    delete this.objectErrors.url;
                }
            }
        },
        imagesDragEndHandler(e) {
            const imagesLength = this.content.images.length;
            let imagesArray = [...this.content.images];
            const oldPositionImage = { ...imagesArray[e.oldIndex] };
            let newImagesArray = [];
            imagesArray.splice(e.oldIndex, 1);

            for (let i = 0; i < imagesLength; i++) {
                if (i == e.newIndex) {
                    newImagesArray.push(oldPositionImage);
                    if (imagesArray[i]) {
                        newImagesArray.push(imagesArray[i]);
                    }
                } else if (imagesArray[i]) {
                    newImagesArray.push(imagesArray[i]);
                }
            }
            this.content.images = newImagesArray;
        },
        filesDragEndHandler(e) {
            const filesLength = this.content.files.length;
            let filesArray = [...this.content.files];
            const oldPositionFile = { ...filesArray[e.oldIndex] };
            let newFilesArray = [];
            filesArray.splice(e.oldIndex, 1);

            for (let i = 0; i < filesLength; i++) {
                if (i == e.newIndex) {
                    newFilesArray.push(oldPositionFile);
                    if (filesArray[i]) {
                        newFilesArray.push(filesArray[i]);
                    }
                } else if (filesArray[i]) {
                    newFilesArray.push(filesArray[i]);
                }
            }
            this.content.files = newFilesArray;
        },
    },
};
</script>

<style scoped>
@import '~tippy.js/animations/shift-away.css';
@import '../assets/css/tippylabyloksolid.css';
@import '~vue2-dropzone/dist/vue2Dropzone.min.css';

.tabs.is-toggle li.is-active a,
.tabs.is-toggle li.project-content-modal a {
    background-color: #0074d9;
    border-color: #0074d9;
    color: #fff !important;
    z-index: 1;
}

textarea {
    min-height: 3rem !important;
    resize: vertical;
}
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}
.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}
.lb-accordion {
    overflow-y: auto;
    max-height: calc(100vh - 13rem);
    overflow-x: hidden;
}
.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body.is-collapsible {
    overflow-x: hidden;
}
.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}
.action-buttons button {
    height: 60px;
}

.lb-bordered {
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    box-shadow: inset 0 0.0625em 0.125em rgb(74 74 74 / 5%);
}

.lb-bordered:hover {
    border: 1px solid #b5b5b5;
}

.lb-bordered:focus-within {
    border: 1px solid #4a4a4a;
}

.lb-bordered /deep/ .buttons {
    border-radius: 4px 4px 0 0;
    margin-bottom: 0;
}
.lb-bordered /deep/ .editor__content {
    padding: 0.75rem;
}
.lb-bordered /deep/ .is-empty.editor-empty {
    display: none;
}
.is-borderless-left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
}
.is-radiusless-right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.creation-helper:hover {
    cursor: pointer;
}
.creation-helper:hover i {
    color: #0074d9;
}

.dropzone {
    min-height: 80px;
    border-radius: 4px;
    border-width: 1px;
}
.sortable {
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style-type: none;
}
.sortable li {
    float: left;
    width: 115px;
    height: 115px;
    overflow: hidden;
    border: 1px solid #0074d9;
    text-align: center;
    margin: 5px;
    border-radius: 4px;
}
.sortable li:last-child {
    margin-bottom: 2rem;
}
.sortable li:hover {
    cursor: move;
}
li.sortable-placeholder {
    border: 1px dashed #ccc;
    background: none;
}

#accordion_new_object-images .dz-remove {
    position: relative;
    bottom: 88px;
    background-color: rgba(255, 255, 255, 0.6);
    float: right;
    padding: 4px;
    border-top-left-radius: 4px;
}
#accordion_new_object-images .dz-filename {
    position: relative;
    bottom: 113px;
    background-color: rgba(255, 255, 255, 0.6);
    padding-bottom: 2px;
    padding-top: 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

#accordion_new_object-audio .dropzone-previews,
#accordion_new_object-files .dropzone-previews {
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style-type: none;
}
#accordion_new_object-audio .dropzone-previews li,
#accordion_new_object-files .dropzone-previews li {
    border: 1px solid #0074d9;
    border-radius: 4px;
}

.validationErrors {
    position: absolute;
    z-index: +1;
    top: 20%;
}

.validationErrors .notification {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

#accordion_new_object-images .dz-preview.dz-file-preview .image.is-1by1 img {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
}
</style>
